export default __webpack_public_path__ + "static/7836a4944a134ff57b39fbd6f3ac5d53.ttf";